import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-modal-exito',
  templateUrl: './modal-exito.component.html',
  styleUrls: ['./modal-exito.component.scss']
})
export class ModalExitoComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnText: string;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void { }

  public dismiss(): void {
    this.bsModalRef.hide();
  }
}
